var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 123,
    viewBox: "0 0 177 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.432 112.628H35.2081C13.1794 112.628 0.5 98.5321 0.5 81.1073C0.5 66.02 10.062 54.1204 24.2289 50.0826C26.708 21.8211 49.9411 0.5 77.4248 0.5C98.4618 0.5 115.745 11.9038 125.166 30.6043C150.878 30.6043 169.79 48.1706 169.79 71.474C169.79 94.5656 151.302 112.628 127.432 112.628Z",
    fill: "url(#paint0_linear_2002_55)",
    stroke: "url(#paint1_linear_2002_55)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 13.6227,
    y: 8.60432,
    width: 182.519,
    height: 134.343
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_0_2002_55_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 20,
    d: "M98.3815 28.9793C115.942 28.9793 130.368 38.4861 138.239 54.1013L138.343 54.3091H138.575C160.044 54.3091 175.767 68.9507 175.767 88.3217C175.767 107.533 160.382 122.572 140.484 122.572H62.8414C53.6507 122.572 46.4443 119.634 41.5383 114.914C36.6314 110.194 33.9977 103.664 33.9977 96.4264C33.9977 83.9085 41.9288 74.0384 53.7019 70.6851L53.9508 70.6128L53.9729 70.3559C56.0435 46.7655 75.4435 28.9793 98.3815 28.9793Z",
    fill: "#B9DDFF",
    fillOpacity: 0.6,
    stroke: "url(#paint2_linear_2002_55)",
    strokeWidth: 0.75
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2002_55_clip_path",
    transform: "translate(-13.6227 -8.60432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.3815 28.9793C115.942 28.9793 130.368 38.4861 138.239 54.1013L138.343 54.3091H138.575C160.044 54.3091 175.767 68.9507 175.767 88.3217C175.767 107.533 160.382 122.572 140.484 122.572H62.8414C53.6507 122.572 46.4443 119.634 41.5383 114.914C36.6314 110.194 33.9977 103.664 33.9977 96.4264C33.9977 83.9085 41.9288 74.0384 53.7019 70.6851L53.9508 70.6128L53.9729 70.3559C56.0435 46.7655 75.4435 28.9793 98.3815 28.9793Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2002_55",
    x1: 49.3339,
    y1: 25.0278,
    x2: 163.747,
    y2: 84.4325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FC0FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4088F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2002_55",
    x1: 0.0505542,
    y1: 0.0490887,
    x2: 170.578,
    y2: 112.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644134,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2002_55",
    x1: 33.6213,
    y1: 28.6029,
    x2: 176.143,
    y2: 122.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644134,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudy);
export default __webpack_public_path__ + "static/media/Cloudy.4da1cfe2dc45c592a3139dbc85a03b2c.svg";
export { ForwardRef as ReactComponent };